const hashCode = function hashCode(str: string): number {
  let hash = 0;
  let i;
  let chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i);
    // eslint-disable-next-line
    hash = (hash << 5) - hash + chr;
    // eslint-disable-next-line
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

/**
 * 去重队列,特定时间内(默认500毫秒)相同参数的事件只会回调一次
 */
export default class SingleTask {
  interval: number = 500; // 间隔时间毫秒

  taskMap: Record<string, any> = {};

  timerMap: Record<string, any> = {};

  constructor(interval?: number) {
    interval && (this.interval = interval);
  }

  /**
   * 添加任务参数
   * @param params 参数
   * @param callback 回调方法，特定时间内(默认100毫秒)相同参数的事件只会回调一次
   * @param customHashStr 自定义hash字符串
   */
  add(params: any, callback: Function, customHashStr?: string): boolean {
    const hash = customHashStr ? hashCode(customHashStr) : hashCode(window.location.href + JSON.stringify(params));
    if (!this.taskMap[hash]) {
      callback(params);
      this.taskMap[hash] = params;
      this.timerMap[hash] = setTimeout(() => {
        clearTimeout(this.timerMap[hash]);
        delete this.timerMap[hash];
        delete this.taskMap[hash];
      }, this.interval);
      return true;
    }
    return false;
  }
}
